/* Nuvò · Tutti i prodotti · filtri per tipo, ordinamento, «Aggiungi al carrello» senza cambiare pagina */
(function () {
  if (window.__nuvoColl) return;
  window.__nuvoColl = true;

  function root() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  function initShop(shop) {
    var cards = Array.prototype.slice.call(shop.querySelectorAll('[data-nc-card]'));
    var boxes = Array.prototype.slice.call(shop.querySelectorAll('[data-nc-box]'));
    var count = shop.querySelector('[data-nc-count]');
    var total = count ? count.getAttribute('data-total') : '';
    // Testi tradotti (arrivano dalla sezione, in base alla lingua)
    var tOne = shop.getAttribute('data-t-one') || 'prodotto';
    var tMany = shop.getAttribute('data-t-many') || 'prodotti';
    var tAdded = shop.getAttribute('data-t-added') || 'Aggiunto';

    // Filtri per tipo di prodotto (collezioni scelte nei blocchi «Filtro»)
    shop.addEventListener('click', function (e) {
      var btn = e.target.closest ? e.target.closest('[data-nc-filter]') : null;
      if (!btn || !shop.contains(btn)) return;
      var handle = btn.getAttribute('data-nc-filter');
      var all = handle === '';
      var shown = 0;
      shop.querySelectorAll('[data-nc-filter]').forEach(function (b) {
        var on = b === btn;
        b.classList.toggle('is-on', on);
        b.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
      cards.forEach(function (c) {
        var colls = (c.getAttribute('data-colls') || '').split(' ');
        var ok = all || colls.indexOf(handle) !== -1;
        c.hidden = !ok;
        if (ok) shown++;
      });
      boxes.forEach(function (b) { b.hidden = !all; });
      if (count) {
        var n = all && total ? total : String(shown);
        count.textContent = n + ' ' + (n === '1' ? tOne : tMany);
      }
    });

    // Ordinamento
    var sort = shop.querySelector('[data-nc-sort]');
    // «Ordina per»: il riquadro è largo quanto il testo della voce scelta (+ spazio per la freccia)
    function fitSort() {
      if (!sort || !sort.options.length) return;
      var cs = window.getComputedStyle(sort);
      var probe = document.createElement('span');
      probe.style.cssText = 'position:absolute;visibility:hidden;white-space:nowrap;left:-9999px;top:0';
      probe.style.font = cs.font;
      probe.style.letterSpacing = cs.letterSpacing;
      probe.textContent = sort.options[sort.selectedIndex].text;
      document.body.appendChild(probe);
      var w = probe.getBoundingClientRect().width;
      document.body.removeChild(probe);
      var extra = parseFloat(cs.paddingLeft) + parseFloat(cs.paddingRight) + parseFloat(cs.borderLeftWidth) + parseFloat(cs.borderRightWidth);
      sort.style.width = Math.ceil(w + extra + 2) + 'px';
    }
    if (sort) {
      fitSort();
      if (document.fonts && document.fonts.ready) document.fonts.ready.then(fitSort);
      window.addEventListener('resize', fitSort);
      sort.addEventListener('change', fitSort);
      sort.addEventListener('change', function () {
        var url = new URL(window.location.href);
        url.searchParams.set('sort_by', sort.value);
        url.searchParams.delete('page');
        window.location.href = url.toString();
      });
    }

    // Aggiungi al carrello
    shop.addEventListener('submit', function (e) {
      var form = e.target;
      if (!form.matches || !form.matches('[data-nc-add]')) return;
      if (!window.fetch || !window.FormData) return;
      e.preventDefault();
      var btn = form.querySelector('button');
      var label = btn.textContent;
      btn.disabled = true;
      fetch(root() + 'cart/add.js', {
        method: 'POST',
        headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: new FormData(form)
      })
        .then(function (r) { if (!r.ok) throw new Error('add'); return r.json(); })
        .then(function () { return fetch(root() + 'cart.js', { headers: { Accept: 'application/json' } }); })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          btn.textContent = tAdded;
          document.querySelectorAll('.cart-count-bubble span[aria-hidden], [data-cart-count], .cart-count, .header__cart-count').forEach(function (el) {
            el.textContent = cart.item_count;
          });
          document.dispatchEvent(new CustomEvent('cart:refresh', { detail: { cart: cart } }));
          setTimeout(function () { btn.textContent = label; btn.disabled = false; }, 1800);
        })
        .catch(function () { btn.disabled = false; form.submit(); });
    });
  }

  function start() {
    document.querySelectorAll('[data-nc-shop]').forEach(function (shop) {
      if (shop.__nc) return;
      shop.__nc = true;
      initShop(shop);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
  document.addEventListener('shopify:section:load', start);
})();
